import { useEffect } from 'react';
type SeoContent = {
  title: string;
  description: string;
  image: string;
};

function upsertMeta(selector: string, attribute: 'content', value: string) {
  const existing = document.head.querySelector<HTMLMetaElement>(selector);

  if (existing) {
    existing.setAttribute(attribute, value);
  }
}

export function useSeo(seo: SeoContent) {
  useEffect(() => {
    document.title = seo.title;
    upsertMeta('meta[name="description"]', 'content', seo.description);
    upsertMeta('meta[property="og:title"]', 'content', seo.title);
    upsertMeta('meta[property="og:description"]', 'content', seo.description);
    upsertMeta('meta[property="og:image"]', 'content', seo.image);
    upsertMeta('meta[name="twitter:title"]', 'content', seo.title);
    upsertMeta('meta[name="twitter:description"]', 'content', seo.description);
    upsertMeta('meta[name="twitter:image"]', 'content', seo.image);
  }, [seo]);
}
